export default __webpack_public_path__ + "static/scale_icon-999f0eee043e0b9cc13454c644c4421b.svg";